export default __webpack_public_path__ + "static/media/double-arrow-left.b6e3a6fe.svg";